import React, { useEffect, useState } from 'react'

interface SelectProps {
  options: string[]
  idSelect: string
  customClassName?: string
  isDefaultNone?: boolean
  highlightError?: boolean
  isDisabled?: boolean
  value?: string
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void
}

/** Componente Select che permette all'utente di selezionare diverse opzioni tra quelle disponibili
 *
 * @param options le opzioni tra cui l'utente può scegliere
 * @param idSelect id del componente
 * @param onChange funzione chiamata quando si seleziona un opzione differente dalla precedente
 * @param value valore assunto dalla select in base all'opzione selezionata
 * @param customClassName le classi da aggiungere oltre a quelle pre-esistenti
 * @param isDefaultNone se true, la prima opzione (default) è la string vuota
 * @param highlightError se true, la select verrà evidenziata di rosso se c'è un errore associato
 * @param isDisabled se true, la select è disabilitata
 */
const Select = ({
  options,
  idSelect,
  onChange,
  value,
  customClassName = '',
  isDefaultNone = false,
  highlightError = false,
  isDisabled = false
}: SelectProps) => {
  const [selectedOption, setSelectedOption] = useState('')
  const [isError, setIsError] = useState(false)

  const handleOnBlur = () => {
    // quando perdo il focus, l'errore deve visualizzarsi solo quando è selezionata l'option di default
    if (!selectedOption) setIsError(true)
  }

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value
    setSelectedOption(value)

    // Rimuove il bordo rosso quando un'opzione diversa da quella di default è selezionata
    if (value) {
      setIsError(false)
    } else {
      setIsError(true)
    }

    if (onChange) onChange(event)
  }

  useEffect(() => {
    setSelectedOption(value ?? '')
  }, [value])

  /*TODO: controllare spaziature nelle option e nelle select nascoste*/
  return (
    <div className={'px-3.7 mb-3.7 flex'}>
      <select
        id={idSelect}
        disabled={isDisabled}
        onBlur={handleOnBlur}
        onChange={handleChange}
        className={`${highlightError && isError ? 'border-borderRed' : ''} ${isDisabled ? 'cursor-not-allowed opacity-100' : ''} ${customClassName}`}
        value={selectedOption}>
        {isDefaultNone && <option value={''}></option>}
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  )
}

export default Select
